export const FIND_POOL_REQUEST_SUCCESS = 'FIND_POOL_REQUEST_SUCCESS';

export const findPoolRequestSuccess = poolRequest => ({
    type: FIND_POOL_REQUEST_SUCCESS,
    payload: { poolRequest },
});
